// extracted by mini-css-extract-plugin
export var externalLink = "_ah-0";
export var internalLinkLabel = "_ah-1";